/* ============================================================
   SKILLS LAB · Expanding brackets
   Engine (EBQ, verbatim from the live tool) + one teach renderer
   shared by four skills: single, double, triple, surds.
   ============================================================ */
(function () {
  'use strict';
  var SL = window.SL; if (!SL) return;
  var MINUS = SL.MINUS;

  /* ============================================================
     QUESTION ENGINE (pure data, no DOM)
     ============================================================ */
  var EBQ = (function () {
    function ri(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
    function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
    function chance(p) { return Math.random() < p; }
    function collect(terms) {
      var by = {}, i, k, out = [], r = null;
      for (i = 0; i < terms.length; i++) { by[terms[i].p] = (by[terms[i].p] || 0) + terms[i].c; if (terms[i].r) r = terms[i].r; }
      for (k in by) if (Object.prototype.hasOwnProperty.call(by, k)) out.push(r ? { c: by[k], p: Number(k), r: r } : { c: by[k], p: Number(k) });
      out.sort(function (a, b) { return r ? a.p - b.p : b.p - a.p; });
      out = out.filter(function (t) { return t.c !== 0; });
      return out.length ? out : [r ? { c: 0, p: 0, r: r } : { c: 0, p: 0 }];
    }
    function products(A, B) {
      var out = [], i, j, t, r;
      for (i = 0; i < A.length; i++) for (j = 0; j < B.length; j++) {
        t = { c: A[i].c * B[j].c, p: A[i].p + B[j].p, ai: i, bi: j };
        r = A[i].r || B[j].r;
        if (r) { t.r = r; if (t.p >= 2) { t.c *= Math.pow(r, t.p >> 1); t.p = t.p % 2; } }
        out.push(t);
      }
      return out;
    }
    function mul(A, B) { return collect(products(A, B)); }
    function mulAll(fs) { var r = fs[0], i; for (i = 1; i < fs.length; i++) r = mul(r, fs[i]); return r; }
    function scale(A, k) { return A.map(function (t) { return t.r ? { c: t.c * k, p: t.p, r: t.r } : { c: t.c * k, p: t.p }; }); }
    function deg(A) { return A.reduce(function (m, t) { return Math.max(m, t.p); }, 0); }
    function maxAbs(A) { return A.reduce(function (m, t) { return Math.max(m, Math.abs(t.c)); }, 0); }
    function xPart(p, r) { if (r) return p === 0 ? '' : (p === 1 ? '√' + r : '(√' + r + ')^' + p); return p === 0 ? '' : (p === 1 ? 'x' : 'x^' + p); }
    function termText(t, first) { var a = Math.abs(t.c), s = ''; if (t.c < 0) s = first ? '-' : ' - '; else if (!first) s = ' + '; if (a !== 1 || t.p === 0) s += a; return s + xPart(t.p, t.r); }
    function polyText(A) { var s = '', i; for (i = 0; i < A.length; i++) s += termText(A[i], i === 0); return s; }
    function factorText(A) { return A.length === 1 ? polyText(A) : '(' + polyText(A) + ')'; }
    function qText(q) {
      var i, s = '', p;
      if (q.parts) { for (i = 0; i < q.parts.length; i++) { p = q.parts[i]; if (i > 0) s += p.neg ? ' - ' : ' + '; s += p.factors.map(factorText).join(''); } return s; }
      if (q.shape === 'square' || q.shape === 'ssq') return factorText(q.factors[0]) + '^2';
      return q.factors.map(factorText).join('');
    }
    function qKey(q) { return q.shape + '|' + qText(q).replace(/\d+/g, '#'); }
    function coefOf(cfg) { if (!cfg.big) return 1; return chance(0.6) ? ri(2, 6) : 1; }
    function sgn(cfg, p) { return (cfg.neg && chance(p === undefined ? 0.5 : p)) ? -1 : 1; }
    function binom(cfg, maxConst) { var a = coefOf(cfg) * (cfg.big && cfg.neg && chance(0.18) ? -1 : 1); var b = ri(1, maxConst || cfg.cmax || 12) * sgn(cfg); return [{ c: a, p: 1 }, { c: b, p: 0 }]; }
    function trinom(cfg) { var a = cfg.big && chance(0.35) ? ri(2, 4) : 1; var b = ri(1, 9) * sgn(cfg); var c = ri(1, 9) * sgn(cfg); return [{ c: a, p: 2 }, { c: b, p: 1 }, { c: c, p: 0 }]; }
    function mult(cfg, lo, hi) { return [{ c: ri(lo || 2, hi || 9) * sgn(cfg, 0.35), p: 0 }]; }
    function xterm(cfg) { return [{ c: coefOf(cfg) * sgn(cfg, 0.3), p: 1 }]; }
    function bracket(cfg, maxConst) { return (cfg.terms >= 3 && chance(0.5)) ? trinom(cfg) : binom(cfg, maxConst); }
    function abs(t) { return t.r ? { c: Math.abs(t.c), p: t.p, r: t.r } : { c: Math.abs(t.c), p: t.p }; }
    function clone(A) { return A.map(function (t) { return t.r ? { c: t.c, p: t.p, r: t.r } : { c: t.c, p: t.p }; }); }
    var SHAPES = {
      num: function (cfg) { return { factors: [mult(cfg), bracket(cfg)] }; },
      term: function (cfg) { return { factors: [xterm(cfg), bracket(cfg)] }; },
      two: function (cfg) {
        var withX = cfg.big && chance(0.3);
        var m1 = withX ? xterm(cfg) : mult(cfg, 2, 7), m2 = mult(cfg, 2, 7), neg = cfg.neg && chance(0.55);
        return { parts: [{ factors: [m1.map(abs), bracket(cfg, 9)], neg: false }, { factors: [m2.map(abs), bracket(cfg, 9)], neg: neg }] };
      },
      pair: function (cfg) { return { factors: [bracket(cfg), bracket(cfg)] }; },
      square: function (cfg) { var b = bracket(cfg); return { factors: [b, clone(b)] }; },
      three: function (cfg) {
        var f = [clone(binom(cfg, 7)), clone(binom(cfg, 7)), clone(binom(cfg, 7))], i, hot = ri(0, 2);
        if (cfg.terms >= 3 && chance(0.45)) f[ri(0, 2)] = trinom(cfg);
        for (i = 0; i < 3; i++) if (i !== hot) f[i][0].c = f[i][0].c < 0 ? -1 : 1;
        return { factors: f };
      }
    };
    var SURDS = [2, 3, 5, 6, 7, 10];
    function sbin(cfg, n) { var a = ri(1, 7); var b = (cfg.big && chance(0.6) ? ri(2, 3) : 1) * sgn(cfg); return [{ c: a, p: 0, r: n }, { c: b, p: 1, r: n }]; }
    SHAPES.sout = function (cfg) { var n = pick(SURDS); var k = cfg.big && chance(0.5) ? ri(2, 3) : 1; var b = cfg.big && chance(0.6) ? ri(2, 3) : 1; var a = ri(1, 7) * sgn(cfg); return { surd: n, factors: [[{ c: k, p: 1, r: n }], [{ c: b, p: 1, r: n }, { c: a, p: 0, r: n }]] }; };
    SHAPES.spair = function (cfg) { var n = pick(SURDS); return { surd: n, factors: [sbin(cfg, n), sbin(cfg, n)] }; };
    SHAPES.ssq = function (cfg) { var n = pick(SURDS), b = sbin(cfg, n); return { surd: n, factors: [b, clone(b)] }; };
    SHAPES.sconj = function (cfg) { var n = pick(SURDS); var a = ri(1, 7), b = cfg.big && chance(0.6) ? ri(2, 3) : 1; var f1 = [{ c: a, p: 0, r: n }, { c: b, p: 1, r: n }]; var f2 = [{ c: a, p: 0, r: n }, { c: -b, p: 1, r: n }]; return { surd: n, factors: chance(0.5) ? [f1, f2] : [f2, f1] }; };
    var POOLS = { single: [['num', 38], ['term', 32], ['two', 30]], double: [['pair', 68], ['square', 32]], triple: [['three', 100]], surd: [['sout', 24], ['spair', 36], ['ssq', 20], ['sconj', 20]] };
    var SHAPE_DOOR = { num: 'single', term: 'single', two: 'single', pair: 'double', square: 'double', three: 'triple', sout: 'surd', spair: 'surd', ssq: 'surd', sconj: 'surd' };
    function pool(door, cfg) {
      var all = door === 'mix' ? POOLS.single.concat(POOLS.double, POOLS.triple) : POOLS[door], on;
      if (!cfg.types || !cfg.types.length) return all;
      on = all.filter(function (e) { return cfg.types.indexOf(e[0]) >= 0; });
      return on.length ? on : all;
    }
    function weighted(list) { var total = 0, i, r; for (i = 0; i < list.length; i++) total += list[i][1]; r = Math.random() * total; for (i = 0; i < list.length; i++) { r -= list[i][1]; if (r < 0) return list[i][0]; } return list[0][0]; }
    function ok(q, door, cfg) {
      var ans = q.ans, i, f;
      var wide = !!(q.factors && q.factors.some(function (g) { return g.length > 2; }));
      var cap = cfg && cfg.cap ? cfg.cap : (door === 'triple' ? (wide ? 340 : 260) : 220);
      if (maxAbs(ans) > cap) return false;
      if (ans.length === 1 && ans[0].c === 0) return false;
      if (q.parts) { if (ans.length < 2) return false; if (deg(ans) < 1) return false; return true; }
      for (i = 0; i < q.factors.length; i++) { f = q.factors[i]; if (f.length > 1 && f[f.length - 1].c === 0) return false; }
      if (q.shape === 'three') { var k = 1; for (i = 0; i < 3; i++) k *= Math.abs(q.factors[i][q.factors[i].length - 1].c); if (k > (wide ? 110 : 180)) return false; }
      return true;
    }
    function expandOf(q) {
      if (q.parts) { var out = [], i, p, pr, j; for (i = 0; i < q.parts.length; i++) { p = q.parts[i]; pr = products(p.neg ? scale(p.factors[0], -1) : p.factors[0], p.factors[1]); for (j = 0; j < pr.length; j++) { pr[j].part = i; out.push(pr[j]); } } return out; }
      return products(q.factors[0], q.factors[1]);
    }
    function answerOf(q) { if (q.parts) return collect(expandOf(q)); return mulAll(q.factors); }
    function make(door, cfg, want) {
      var tries = 0, shape, q, actual;
      if (!cfg.terms) cfg.terms = 2;
      while (tries++ < 400) {
        shape = want || weighted(pool(door, cfg)); actual = SHAPE_DOOR[shape] || door;
        q = SHAPES[shape](cfg); q.shape = shape; q.door = actual; q.ans = answerOf(q);
        if (ok(q, actual, cfg)) return q;
      }
      q = SHAPES.num({ neg: false, big: false, terms: 2 }); q.shape = 'num'; q.door = door; q.ans = answerOf(q); return q;
    }
    function next(door, cfg, seen, shapeSeen, want) {
      var i, q, key, mask, tries = want ? 140 : 60;
      for (i = 0; i < tries; i++) {
        q = make(door, cfg);
        if (want && !want(q)) continue;
        key = qText(q); mask = qKey(q);
        if (seen[key]) continue;
        if (i < tries - 20 && shapeSeen[mask]) continue;
        seen[key] = 1; shapeSeen[mask] = 1; return q;
      }
      for (i = 0; i < 30; i++) { q = make(door, cfg); if (!want || want(q)) break; }
      seen[qText(q)] = 1; return q;
    }
    return { chance: chance, collect: collect, products: products, scale: scale, polyText: polyText, factorText: factorText, qText: qText, expandOf: expandOf, make: make, next: next };
  })();

  /* ============================================================
     LEVELS (one set of levels per door, as on the live tool)
     ============================================================ */
  /* a surd in a level example, drawn like the working: the bar runs over the whole number
     (Aadam, 2026-09-15, "fix the square roots everywhere"), never a √ glyph at the start */
  function SR(n) { return '<span class="eb-srd"><svg class="eb-rad" viewBox="0 0 24 40" aria-hidden="true"><path d="M2 23 L7 21 L12 36 L22.4 2.4"/></svg><span>' + n + '</span></span>'; }
  var LEVELS = {
    single: [
      { name: 'Number outside', eg: '3(x + 4)', neg: 0, big: 0, terms: 2, types: ['num'] },
      { name: 'Number outside, with negatives', eg: '3(x ' + MINUS + ' 4)', neg: 1, big: 0, terms: 2, types: ['num'], must: ['neg'] },
      { name: 'x outside', eg: 'x(x + 3)', neg: 0, big: 0, terms: 2, types: ['term'] },
      { name: 'x outside, with negatives and coefficients', eg: '2x(3x ' + MINUS + ' 1)', neg: 1, big: 1, terms: 2, types: ['term'], must: ['neg', 'big'] },
      { name: 'Three terms inside the bracket', eg: '3(x<sup>2</sup> + 2x ' + MINUS + ' 4)', neg: 1, big: 1, terms: 3, types: ['num', 'term'], must: ['terms'] },
      { name: 'Two brackets, then collect like terms', eg: '3(x + 2) + 4(x + 1)', neg: 0, big: 0, terms: 2, types: ['two'] },
      { name: 'Two brackets, with negatives', eg: '3(x + 2) ' + MINUS + ' 4(x ' + MINUS + ' 1)', neg: 1, big: 1, terms: 2, types: ['two'], must: ['neg'] },
      { name: 'Everything mixed', eg: 'any of the above, at random', neg: -1, big: -1, terms: -1, types: ['num', 'term', 'two'] }
    ],
    double: [
      { name: 'Two brackets', eg: '(x + 2)(x + 5)', neg: 0, big: 0, terms: 2, types: ['pair'] },
      { name: 'Two brackets, with negatives', eg: '(x ' + MINUS + ' 3)(x + 4)', neg: 1, big: 0, terms: 2, types: ['pair'], must: ['neg'] },
      { name: 'A bracket squared', eg: '(x + 5)<sup>2</sup>', neg: 0, big: 0, terms: 2, types: ['square'] },
      { name: 'Squared, with negatives', eg: '(x ' + MINUS + ' 5)<sup>2</sup>', neg: 1, big: 0, terms: 2, types: ['square'], must: ['neg'] },
      /* neg 0.65: signs mixed, about half the questions carry a negative (Aadam, 2026-09-16, "level 5 has no negatives") */
      { name: 'A coefficient in front of the x', eg: '(2x + 3)(x + 4)', neg: 0.65, big: 1, terms: 2, types: ['pair', 'square'], must: ['big'] },
      { name: 'Coefficients and negatives', eg: '(3x ' + MINUS + ' 2)(2x + 5)', neg: 1, big: 1, terms: 2, types: ['pair', 'square'], must: ['neg', 'big'] },
      { name: 'Three terms in a bracket', eg: '(x<sup>2</sup> + 2x + 3)(x + 4)', neg: 0, big: 0, terms: 3, types: ['pair'], must: ['terms'] },
      { name: 'Three terms, negatives and coefficients', eg: '(x<sup>2</sup> ' + MINUS + ' 3x + 2)(2x ' + MINUS + ' 1)', neg: 1, big: 1, terms: 3, types: ['pair', 'square'], must: ['terms', 'neg', 'big'] },
      { name: 'Everything mixed', eg: 'any of the above, at random', neg: -1, big: -1, terms: -1, types: ['pair', 'square'] }
    ],
    triple: [
      { name: 'Three brackets', eg: '(x + 1)(x + 2)(x + 3)', neg: 0, big: 0, terms: 2, types: ['three'] },
      { name: 'With negatives', eg: '(x ' + MINUS + ' 1)(x + 2)(x ' + MINUS + ' 3)', neg: 1, big: 0, terms: 2, types: ['three'], must: ['neg'] },
      { name: 'A coefficient in front of one x', eg: '(2x + 1)(x + 2)(x + 3)', neg: 0, big: 1, terms: 2, types: ['three'], must: ['big'] },
      { name: 'Coefficients and negatives', eg: '(2x ' + MINUS + ' 1)(x + 2)(x ' + MINUS + ' 3)', neg: 1, big: 1, terms: 2, types: ['three'], must: ['neg', 'big'] },
      { name: 'One bracket holds three terms', eg: '(x<sup>2</sup> + 2x + 1)(x + 2)(x + 3)', neg: 0, big: 0, terms: 3, types: ['three'], must: ['terms'] },
      { name: 'Everything mixed', eg: 'any of the above, at random', neg: -1, big: -1, terms: -1, types: ['three'] }
    ],
    surd: [
      { name: 'Surd outside a bracket', eg: SR(2) + '(' + SR(2) + ' + 3)', neg: 0, big: 0, terms: 2, types: ['sout'] },
      { name: 'Surd outside, with negatives', eg: SR(3) + '(' + SR(3) + ' ' + MINUS + ' 4)', neg: 1, big: 0, terms: 2, types: ['sout'], must: ['neg'] },
      { name: 'Two brackets', eg: '(2 + ' + SR(3) + ')(1 + ' + SR(3) + ')', neg: 0, big: 0, terms: 2, types: ['spair'] },
      { name: 'Two brackets, with negatives', eg: '(2 ' + MINUS + ' ' + SR(3) + ')(1 + ' + SR(3) + ')', neg: 1, big: 0, terms: 2, types: ['spair'], must: ['neg'] },
      { name: 'A bracket squared', eg: '(1 + ' + SR(2) + ')<sup>2</sup>', neg: 0, big: 0, terms: 2, types: ['ssq'] },
      { name: 'Squared, with negatives', eg: '(3 ' + MINUS + ' ' + SR(5) + ')<sup>2</sup>', neg: 1, big: 0, terms: 2, types: ['ssq'], must: ['neg'] },
      { name: 'Difference of two squares', eg: '(3 + ' + SR(2) + ')(3 ' + MINUS + ' ' + SR(2) + ')', neg: 1, big: 0, terms: 2, types: ['sconj'] },
      { name: 'A coefficient in front of the surd', eg: '(2 + 3' + SR(2) + ')(1 ' + MINUS + ' 2' + SR(2) + ')', neg: 1, big: 1, terms: 2, types: ['spair', 'ssq'], must: ['big'] },
      { name: 'Everything mixed', eg: 'any of the above, at random', neg: -1, big: -1, terms: -1, types: ['sout', 'spair', 'ssq', 'sconj'] }
    ]
  };
  /* -1 = either, a fraction = that chance per question, otherwise on or off */
  function rollFlag(v) { return v === -1 ? EBQ.chance(0.5) : (v > 0 && v < 1 ? EBQ.chance(v) : !!v); }
  /* WIDER NUMBERS where a level had too few questions for a window of nine (2026-09-25).
     x(x + a) and (x + a)^2 / (x - a)^2 had 12 questions each (a from 1 to 12), so once
     the last nine were remembered a set of ten could barely be dealt. Same form, same
     name: the constant now runs to 20 for x outside, and to 15 for a bracket squared,
     whose answer reaches 15^2 = 225, just over the engine's 220 cap, so the cap moves too. */
  var WIDE = { single: { 3: { cmax: 20 } }, double: { 3: { cmax: 15, cap: 225 }, 4: { cmax: 15, cap: 225 } } };
  function rollCfg(L, wide) {
    return {
      neg: rollFlag(L.neg),
      big: rollFlag(L.big),
      terms: L.terms === -1 ? (EBQ.chance(0.5) ? 3 : 2) : L.terms,
      types: L.types,
      cmax: wide ? wide.cmax : 0,
      cap: wide ? wide.cap : 0
    };
  }
  /* what a question carries, held against the level's must by the deal kit
     (the same three tests the old levelWant made) */
  function featsOf(q) {
    var polys = q.parts ? q.parts.reduce(function (a, p) { return a.concat(p.factors); }, []) : q.factors, f = [];
    if (EBQ.qText(q).indexOf('-') >= 0) f.push('neg');
    if (polys.some(function (P) { if (q.surd) return P.some(function (t) { return t.p === 1 && Math.abs(t.c) > 1; }); return P[0].p >= 1 && Math.abs(P[0].c) > 1; })) f.push('big');
    if (polys.some(function (P) { return P.length >= 3; })) f.push('terms');
    return f;
  }

  /* ============================================================
     MATHS TO HTML
     ============================================================ */
  var RAD_SVG = '<svg class="eb-rad" viewBox="0 0 24 40" aria-hidden="true"><path d="M2 23 L7 21 L12 36 L22.4 2.4"/></svg>';
  function xHTML(p) { return p === 0 ? '' : (p === 1 ? 'x' : 'x<sup>' + p + '</sup>'); }
  function surdHTML(n) { return '<span class="eb-srd">' + RAD_SVG + '<span>' + n + '</span></span>'; }
  function bodyHTML(t) { var a = Math.abs(t.c); if (t.r) return ((a !== 1 || t.p === 0) ? String(a) : '') + (t.p ? surdHTML(t.r) : ''); return ((a !== 1 || t.p === 0) ? String(a) : '') + xHTML(t.p); }
  function opHTML(neg, first) { if (first) return neg ? '<span class="eb-op eb-op--lead">' + MINUS + '</span>' : ''; return '<span class="eb-op">' + (neg ? MINUS : '+') + '</span>'; }
  function factorHTML(A, fi, pi) {
    var s = '', i;
    for (i = 0; i < A.length; i++) { s += opHTML(A[i].c < 0, i === 0); s += '<span class="eb-tm" data-p="' + (pi || 0) + '" data-f="' + fi + '" data-t="' + i + '">' + bodyHTML(A[i]) + '</span>'; }
    return A.length === 1 ? s : '<span class="eb-br">(</span>' + s + '<span class="eb-br">)</span>';
  }
  function polyHTML(A) { var s = '', i; for (i = 0; i < A.length; i++) { s += opHTML(A[i].c < 0, i === 0); s += '<span class="eb-tm">' + bodyHTML(A[i]) + '</span>'; } return s; }
  /* Typing an algebra answer: one box per COEFFICIENT, with the x term (or the
     surd) printed beside it. The shape of the answer is given, so what is being
     tested is the numbers, and a polynomial no longer has to be tap-to-reveal. */
  function tailHTML(t) { return t.r ? (t.p ? surdHTML(t.r) : '') : xHTML(t.p); }
  /* core hands over the packed question, the same object teach() is given, so
     the engine's own question sits on .data */
  function fieldsFor(item) {
    var q = item && item.data ? item.data : item;
    if (!q || !q.ans || !q.ans.length) return null;
    return q.ans.map(function (t) {
      /* no + before a signed box (Aadam, 2026-09-15, whole app): 3 is +3, only a typed minus makes it negative.
         op must be non-empty or core falls back to '+', so a space. */
      return { ans: String(t.c), after: tailHTML(t), op: ' ', w: Math.max(2, String(t.c).length) };
    });
  }
  function termHTML(t) { return (t.c < 0 ? MINUS : '') + bodyHTML(t); }
  /* a term with its sign, + included, unless it is bare (a leading positive, written with no sign) */
  function signedHTML(t, bare) { return (t.c < 0 ? MINUS : (bare ? '' : '+')) + bodyHTML(t); }
  /* a product is written bare only when it is the first term of the working: the first term of each factor */
  function leadProd(pr) { return !pr.part && pr.ai === 0 && pr.bi === 0; }
  function questionHTML(q) {
    var s = '', i, p;
    if (q.parts) { for (i = 0; i < q.parts.length; i++) { p = q.parts[i]; if (i > 0) s += '<span class="eb-op" data-joinop="' + i + '">' + (p.neg ? MINUS : '+') + '</span>'; s += factorHTML(p.factors[0], 0, i) + factorHTML(p.factors[1], 1, i); } return s; }
    if (q.shape === 'square' || q.shape === 'ssq') return factorHTML(q.factors[0], 0, 0) + '<sup class="eb-sq">2</sup>';
    if (q.door === 'triple') return q.factors.map(function (f, n) { return factorHTML(f, n, 0); }).join('');
    return factorHTML(q.factors[0], 0, 0) + factorHTML(q.factors[1], 1, 0);
  }
  function pairHTML(q, pair) { return factorHTML(q.factors[pair[0]], 0, 0) + factorHTML(q.factors[pair[1]], 1, 0); }
  /* the flat expression used on cards and the board: same markup minus the arc handles */
  function plainHTML(q) { return '<span class="sl-eb-q">' + questionHTML(q) + '</span>'; }

  /* ============================================================
     DEALING, on the deal kit (2026-09-25)
     The last-nine memory used to ride on ctx.seen, and core hands a BRAND-NEW ctx for
     every set of ten (and every ten inside one Speed race), so it was wiped at the seam
     and a question came back a few questions later (5,342 repeats over 300 sets a level).
     The kit keeps the window (key, printed text, answer, the unordered factors) per skill
     and level for the life of the page; only the plan of ten sits on the ctx. One dealer
     per door, so each of the four skills has its own memory.
     ============================================================ */
  /* kinds: a one-shape level deals that shape. A mixed level whose live shares fit a set
     of ten is dealt by quota, close to those shares. A level where one shape is over 6 in
     10 (pairs at 70 to 90%) keeps the engine's own weights and deals as one kind, 'mix'. */
  var QUOTA = { 'single:5': { num: 5, term: 5 }, 'single:8': { num: 4, term: 3, two: 3 }, 'surd:9': { sout: 2, spair: 4, ssq: 2, sconj: 2 } };
  function quotaOf(door, n, L) {
    var o = {};
    if (QUOTA[door + ':' + n]) return QUOTA[door + ':' + n];
    if (L.types.length === 1) { o[L.types[0]] = 10; return o; }
    return { mix: 10 };
  }
  /* near-identical: (x + 2)(x + 5) and (x + 5)(x + 2), (x + 5)(x + 5) and (x + 5)^2 */
  function alsoOf(q) {
    if (q.parts) return [q.parts.map(function (p) { return (p.neg ? '-' : '+') + p.factors.map(EBQ.factorText).join(''); }).sort().join('|')];
    if (q.shape === 'num' || q.shape === 'term' || q.shape === 'sout') return [];
    return [q.factors.map(EBQ.factorText).sort().join('|')];
  }
  /* the sign pattern with the numbers masked: a set of ten still spreads over the patterns
     first, as EBQ.next's shapeSeen did (a per-set tally, so it lives in the kit's S.set) */
  function maskOf(q) { return q.shape + '|' + EBQ.qText(q).replace(/\d+/g, '#'); }
  function pack(q) { return { key: EBQ.qText(q), html: plainHTML(q), text: EBQ.qText(q), ansHTML: polyHTML(q.ans), ansText: EBQ.polyText(q.ans), data: q }; }
  var DEALERS = {};
  function dealerFor(door) {
    if (DEALERS[door]) return DEALERS[door];
    var lastS = null, D;
    var lv = LEVELS[door].map(function (L, i) { return { name: L.name, must: L.must, quota: quotaOf(door, i + 1, L) }; });
    function rollOne(n, kind) {
      var L = LEVELS[door][n - 1], q = EBQ.make(door, rollCfg(L, WIDE[door] && WIDE[door][n]), kind === 'mix' ? null : kind);
      if (L.types.indexOf(q.shape) < 0 || (kind !== 'mix' && q.shape !== kind)) return null;
      q.features = featsOf(q); q.key = EBQ.qText(q);
      /* the must is held here as well as in the kit, or the pattern preference below
         would keep choosing a candidate the kit then throws away */
      if ((L.must || []).some(function (m) { return q.features.indexOf(m) < 0; })) return null;
      return q;
    }
    function roll(n, kind, S) {
      var masks = S.set.masks || (S.set.masks = {}), first = null, q, i;
      lastS = S;
      for (i = 0; i < 4; i++) { q = rollOne(n, kind); if (!q) continue; if (!masks[maskOf(q)]) return q; first = first || q; }
      return first;
    }
    D = SL.kits.deal({ levels: lv, roll: roll, pack: pack, text: EBQ.qText, answer: function (q) { return EBQ.polyText(q.ans); }, also: alsoOf });
    DEALERS[door] = { make: function (level, ctx) { var item = D.make(level, ctx); if (lastS && lastS.set.masks) lastS.set.masks[maskOf(item.data)] = 1; return item; } };
    return DEALERS[door];
  }
  function makeFor(door) {
    return function (level, ctx) { return dealerFor(door).make(level, ctx); };
  }

  /* ============================================================
     TEACH: two presses per product (which terms, then the product) and per collected term
     (which like terms, then the total), so the working is never shown before the pupil can try it
     (Aadam, 2026-09-16)
     ============================================================ */
  function teach(host, item, api) {
    var q = item.data, dead = false, manual = true, fast = !!api.reduceMotion;
    /* Grid method (Aadam, 2026-09-15): the Teach bar's switch swaps the arcs for a multiplication
       grid, one bracket across the top and the other down the side, one box filled per press */
    var boxOn = !!(api.opt && api.opt('grid'));
    host.innerHTML = '<div class="sl-eb' + (boxOn ? ' is-box' + (q.door === 'triple' ? ' is-tri' : '') : '') + (q.door === 'triple' ? ' eb-3' : '') + '"><div class="eb-work"></div><div class="eb-pairs" style="display:none"><span class="eb-steplabel">Which two brackets first?</span><div class="eb-pairrow"></div></div><div class="eb-caption"></div></div>';
    var elWork = host.querySelector('.eb-work'), elPairs = host.querySelector('.eb-pairs'), elPairRow = host.querySelector('.eb-pairrow'), elCap = host.querySelector('.eb-caption');
    /* TEACH FITS THE BOARD (2026-09-22): three brackets stack seven lines of working, taller than a
       laptop board even at the smallest zoom (66px over at 1440x900, 74 at 1024x768). On a board
       wider than it is tall the second multiplication goes beside the first, so the model is about
       half as tall; the presses are the same. Width over height does not change with the zoom. */
    function colsFit() {
      if (q.door !== 'triple') return;
      var w = host.clientWidth, h = host.clientHeight;
      host.firstChild.classList.toggle('is-cols', w > 0 && h > 0 && w >= h * 1.3);
    }
    colsFit();
    var S = { steps: null, step: 0, busy: false, timer: null, lines: [], pair: null, hotLine: null, done: false };
    var PAIRS = [[0, 1, 2], [1, 2, 0], [0, 2, 1]];
    /* which two brackets to multiply first: the two with negatives together if exactly two
       carry a minus, otherwise the two simplest (no coefficient, smallest numbers) */
    function bestPairIndex() {
      if (q.door !== 'triple') return 0;
      var f = q.factors, neg = f.map(function (A) { return A.some(function (t) { return t.c < 0; }); });
      var negCount = neg.filter(Boolean).length, best = 0, bestScore = Infinity;
      PAIRS.forEach(function (pr, n) {
        var A = f[pr[0]], B = f[pr[1]], score = 0;
        if (negCount === 2 && neg[pr[0]] && neg[pr[1]]) score -= 1000;
        [A, B].forEach(function (P) { score += P.length * 10; if (Math.abs(P[0].c) > 1) score += 25; P.forEach(function (t) { score += Math.abs(t.c); }); });
        if (score < bestScore) { bestScore = score; best = n; }
      });
      return best;
    }

    function sameShape(prods, ans) { if (prods.length !== ans.length) return false; for (var i = 0; i < prods.length; i++) if (prods[i].c !== ans[i].c || prods[i].p !== ans[i].p) return false; return true; }
    /* every product gets its own colour, and the two terms that made it light up in the same one */
    function tagColours(prods) { for (var i = 0; i < prods.length; i++) prods[i].col = (i % 6) + 1; return prods; }
    function layoutOf(prods) { if (boxOn) return 'box'; return prods.length > 4 ? 'grid' : 'inline'; }
    function buildSteps(pair) {
      var steps = [], prods, A, B, C, mid, p1, p2;
      if (q.parts) {
        prods = tagColours(EBQ.expandOf(q));
        steps.push({ k: 'exp', prods: prods, layout: layoutOf(prods), line: 0, src: q.parts.map(function (p) { return [p.neg ? EBQ.scale(p.factors[0], -1) : p.factors[0], p.factors[1]]; }) });
        steps.push({ k: 'col', to: q.ans, line: 0 });
        return steps;
      }
      if (q.door === 'triple') {
        A = q.factors[pair[0]]; B = q.factors[pair[1]]; C = q.factors[pair[2]];
        p1 = tagColours(EBQ.products(A, B)); mid = EBQ.collect(p1); p2 = tagColours(EBQ.products(mid, C));
        steps.push({ k: 'exp', prods: p1, layout: layoutOf(p1), line: 1, src: [[A, B]] });
        steps.push({ k: 'col', to: mid, line: 1, restate: [mid, C] });
        steps.push({ k: 'exp', prods: p2, layout: layoutOf(p2), line: 2, src: [[mid, C]] });
        steps.push({ k: 'col', to: q.ans, line: 2 });
        return steps;
      }
      A = q.factors[0]; B = q.factors[1];
      prods = tagColours(EBQ.products(A, B));
      steps.push({ k: 'exp', prods: prods, layout: layoutOf(prods), line: 0, rewrite: q.shape === 'square' || q.shape === 'ssq', src: [[A, B]] });
      if (!sameShape(prods, q.ans)) steps.push({ k: 'col', to: q.ans, line: 0 });
      /* a grid holds the products but never says them as a line: with nothing to collect it is still one press to write it out */
      else if (boxOn) steps.push({ k: 'col', to: q.ans, line: 0, whole: true });
      return steps;
    }
    function stepLabels() {
      if (!S.steps) return ['Choose a pair', 'Expand', 'Simplify', 'Expand', 'Simplify'];
      return S.steps.map(function (st) { return st.k === 'exp' ? 'Expand' : 'Simplify'; });
    }

    /* ---------- drawing ---------- */
    function agePast(keep) {
      Array.prototype.forEach.call(elWork.querySelectorAll('.eb-line'), function (l) {
        if (l === keep || l.classList.contains('is-past')) return;
        l.classList.add('is-past');
        var svg = l.querySelector('.eb-arcs'); if (svg) svg.innerHTML = '';
        boxHotOff(l);
        var wrap = l.querySelector('.eb-exprwrap');
        if (wrap) { wrap.classList.remove('is-guided'); Array.prototype.forEach.call(wrap.querySelectorAll('.is-hot'), function (t) { t.classList.remove('is-hot'); }); }
      });
    }
    function addQuestionLine(html, small) {
      agePast(null);
      var line = document.createElement('div');
      line.className = 'eb-line eb-line--q is-fresh';
      line.innerHTML = '<div class="eb-exprwrap"><svg class="eb-arcs" xmlns="http://www.w3.org/2000/svg"></svg><div class="eb-expr' + (small ? ' eb-expr--sm' : '') + '">' + html + '</div></div>';
      elWork.appendChild(line); S.lines.push(line); return line;
    }
    function addLabel(html) { var e = document.createElement('div'); e.className = 'eb-steplabel'; e.innerHTML = html; elWork.appendChild(e); return e; }
    function gridPlace(prods) {
      var powers = [], fill = {}, cells = [], rows = 0;
      prods.forEach(function (t) { if (powers.indexOf(t.p) < 0) powers.push(t.p); });
      powers.sort(function (a, b) { return b - a; });
      prods.forEach(function (t, i) { var col = powers.indexOf(t.p), row = fill[col] || 0; fill[col] = row + 1; rows = Math.max(rows, row + 1); cells.push({ t: t, col: col, row: row, i: i }); });
      return { powers: powers, cells: cells, rows: rows };
    }
    /* One grid per multiplication. The longer bracket goes across the top so a grid is never taller
       than it is wide; a tie puts the second bracket on top. Headers carry their sign, and each box
       its product with its own. step.cells is indexed by PRODUCT, whatever order the boxes sit in. */
    function boxFor(step, src, pi) {
      var A = src[0], B = src[1], swap = A.length > B.length, top = swap ? A : B, side = swap ? B : A;
      var box = document.createElement('div'), slots = {};
      box.className = 'eb-box';
      box.style.gridTemplateColumns = 'auto repeat(' + top.length + ', minmax(2.4em, auto))';
      /* the multiplier of a second bracket carries the + or − that joins it on */
      function head(t, i, f) { return '<div class="eb-bh" data-hp="' + pi + '" data-hf="' + f + '" data-ht="' + i + '">' + opHTML(t.c < 0, i === 0 && !(pi > 0 && f === 0)) + '<span>' + bodyHTML(t) + '</span></div>'; }
      var html = '<div class="eb-bx">\u00D7</div>';
      top.forEach(function (t, i) { html += head(t, i, swap ? 0 : 1); });
      box.innerHTML = html;
      side.forEach(function (t, row) {
        box.insertAdjacentHTML('beforeend', head(t, row, swap ? 1 : 0));
        top.forEach(function (u, col) { var cell = document.createElement('div'); cell.className = 'eb-bc eb-pt'; box.appendChild(cell); slots[row + ':' + col] = cell; });
      });
      step.prods.forEach(function (pr, i) {
        if ((pr.part || 0) !== pi) return;
        var cell = slots[(swap ? pr.bi : pr.ai) + ':' + (swap ? pr.ai : pr.bi)]; if (!cell) return;
        cell.style.setProperty('--c', 'var(--t' + pr.col + ')');
        cell.innerHTML = '<span class="v">' + signedHTML(pr, leadProd(pr)) + '</span>';
        step.cells[i] = cell;
      });
      return box;
    }
    function addWorkBlock(step) {
      var line = document.createElement('div'); line.className = 'eb-line is-fresh';
      var wrap = document.createElement('div'); wrap.className = 'eb-gridwrap'; line.appendChild(wrap);
      var hostEl;
      if (step.layout === 'box') {
        hostEl = document.createElement('div'); hostEl.className = 'eb-boxes';
        step.cells = [];
        step.src.forEach(function (src, pi) { hostEl.appendChild(boxFor(step, src, pi)); });
      } else if (step.layout === 'grid') {
        step.grid = gridPlace(step.prods);
        hostEl = document.createElement('div'); hostEl.className = 'eb-grid';
        hostEl.style.gridTemplateColumns = 'repeat(' + step.grid.powers.length + ', auto)';
        step.grid.cells.forEach(function (cell) {
          var c = document.createElement('div'); c.className = 'eb-cell eb-pt';
          c.style.gridColumn = String(cell.col + 1); c.style.gridRow = String(cell.row + 1);
          /* colour on the whole term so its sign takes the colour too */
          c.style.color = 'var(--t' + cell.t.col + ')';
          c.innerHTML = opHTML(cell.t.c < 0, cell.i === 0) + '<span>' + bodyHTML(cell.t) + '</span>';
          hostEl.appendChild(c);
        });
      } else {
        hostEl = document.createElement('div'); hostEl.className = 'eb-terms eb-expr eb-expr--sm';
        step.prods.forEach(function (t, i) { var c = document.createElement('span'); c.className = 'eb-pt'; c.style.color = 'var(--t' + t.col + ')'; c.innerHTML = opHTML(t.c < 0, i === 0) + '<span>' + bodyHTML(t) + '</span>'; hostEl.appendChild(c); });
      }
      wrap.appendChild(hostEl); elWork.appendChild(line);
      step.host = hostEl; step.wrap = wrap; step.lineEl = line; return line;
    }
    function keepInView(e) { if (!e) return; try { e.scrollIntoView({ block: 'nearest' }); } catch (err) {} }

    /* ---------- arcs ---------- */
    /* a solid head with its tip at (ex, ey), pointing along the unit vector (ux, uy):
       the same head the sequences kit draws (Aadam 2026-09-16, "improve the look of the arrows") */
    function headD(ex, ey, ux, uy, len, half) {
      var bx = ex - ux * len, by = ey - uy * len, px = -uy * half, py = ux * half, r1 = function (v) { return Math.round(v * 10) / 10; };
      return 'M ' + r1(ex) + ' ' + r1(ey) + ' L ' + r1(bx + px) + ' ' + r1(by + py) + ' Q ' + r1(bx + ux * len * 0.28) + ' ' + r1(by + uy * len * 0.28) + ' ' + r1(bx - px) + ' ' + r1(by - py) + ' Z';
    }
    function arcFor(step, i, instant) {
      var line = S.lines[step.line]; if (!line) return;
      var wrap = line.querySelector('.eb-exprwrap'), svg = wrap.querySelector('.eb-arcs');
      var pr = step.prods[i], pi = pr.part || 0;
      var a = wrap.querySelector('[data-p="' + pi + '"][data-f="0"][data-t="' + pr.ai + '"]');
      var b = wrap.querySelector('[data-p="' + pi + '"][data-f="1"][data-t="' + pr.bi + '"]');
      if (!a || !b) return;
      var W = wrap.offsetWidth, H = 54;
      svg.setAttribute('width', W); svg.setAttribute('height', H); svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.style.width = W + 'px'; svg.style.height = H + 'px';
      var wr = wrap.getBoundingClientRect(), ar = a.getBoundingClientRect(), br = b.getBoundingClientRect();
      var x1 = (ar.left + ar.right) / 2 - wr.left, x2 = (br.left + br.right) / 2 - wr.left;
      var span = Math.abs(x2 - x1), top = Math.max(4, H - 8 - Math.min(38, 12 + span * 0.34));
      Array.prototype.forEach.call(svg.querySelectorAll('.eb-arc, .eb-archead'), function (p) { p.style.opacity = '.26'; });
      while (svg.childNodes.length > 8) svg.removeChild(svg.firstChild);
      /* the arc says WHICH WAY the multiplication goes: a solid head where it lands, lying
         along the curve, and the stroke stopping at the head's base (Aadam 2026-09-16) */
      var cx = (x1 + x2) / 2, cy = top, y0 = H - 5;
      var tx = x2 - cx, ty = y0 - cy, tl = Math.sqrt(tx * tx + ty * ty) || 1, ux = tx / tl, uy = ty / tl;
      var hl = 10, hw = 5.2, sp = 1 - (hl * 0.75) / (tl * 2);
      var ex = (1 - sp) * (1 - sp) * x1 + 2 * (1 - sp) * sp * cx + sp * sp * x2, ey = (1 - sp) * (1 - sp) * y0 + 2 * (1 - sp) * sp * cy + sp * sp * y0;
      var qx = (1 - sp) * x1 + sp * cx, qy = (1 - sp) * y0 + sp * cy;
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('class', 'eb-arc');
      path.setAttribute('d', 'M ' + x1 + ' ' + y0 + ' Q ' + qx + ' ' + qy + ' ' + ex + ' ' + ey);
      path.setAttribute('stroke', 'var(--t' + pr.col + ')');
      svg.appendChild(path);
      var hdEl = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      hdEl.setAttribute('class', 'eb-archead');
      hdEl.setAttribute('d', headD(x2, y0, ux, uy, hl, hw));
      hdEl.setAttribute('style', 'fill:var(--t' + pr.col + ');stroke:none');
      svg.appendChild(hdEl);
      if (fast || instant) return;
      hdEl.style.fillOpacity = '0';
      var len = 0; try { len = path.getTotalLength(); } catch (e) { len = 0; }
      if (!len) return;
      path.style.strokeDasharray = String(len); path.style.strokeDashoffset = String(len);
      var n = 0, frames = 11;
      var iv = setInterval(function () {
        n++; path.style.strokeDashoffset = String(len * (1 - n / frames));
        hdEl.style.fillOpacity = String(Math.max(0, (n / frames - 0.7) / 0.3));
        if (n >= frames) { clearInterval(iv); path.style.strokeDashoffset = '0'; hdEl.style.removeProperty('fill-opacity'); }
      }, 20);
      if (step.arcTimers) step.arcTimers.push(iv);
    }
    function settleArcs(step) {
      (step.arcTimers || []).forEach(function (iv) { clearInterval(iv); }); step.arcTimers = [];
      var line = S.lines[step.line]; if (!line) return;
      Array.prototype.forEach.call(line.querySelectorAll('.eb-arc'), function (p) { p.style.strokeDashoffset = '0'; });
      Array.prototype.forEach.call(line.querySelectorAll('.eb-archead'), function (p) { p.style.removeProperty('fill-opacity'); });
    }
    function clearArcs(i) { var line = S.lines[i]; if (!line) return; var svg = line.querySelector('.eb-arcs'); if (svg) svg.innerHTML = ''; }
    function hotOff(i) {
      var line = S.lines[i]; if (!line) return;
      var wrap = line.querySelector('.eb-exprwrap'); wrap.classList.remove('is-guided');
      Array.prototype.forEach.call(wrap.querySelectorAll('.is-hot'), function (t) { t.classList.remove('is-hot'); t.style.removeProperty('--hot'); });
      boxHotOff(elWork);
    }
    function boxHotOff(root) {
      Array.prototype.forEach.call(root.querySelectorAll('.eb-bh.is-hot'), function (t) { t.classList.remove('is-hot'); t.style.removeProperty('--hot'); });
      Array.prototype.forEach.call(root.querySelectorAll('.eb-boxes.is-guided, .eb-bc.is-now'), function (t) { t.classList.remove('is-guided'); t.classList.remove('is-now'); });
    }
    function hotOn(step, i) {
      var line = S.lines[step.line]; if (!line) return;
      var wrap = line.querySelector('.eb-exprwrap'), pr = step.prods[i], pi = pr.part || 0;
      wrap.classList.add('is-guided');
      Array.prototype.forEach.call(wrap.querySelectorAll('.is-hot'), function (t) { t.classList.remove('is-hot'); t.style.removeProperty('--hot'); });
      /* the sign lights with its term, + as well as − (Aadam, 2026-09-16: look at the sign first);
         a second bracket's multiplier takes its sign from the + or − that joins it on */
      function lite(e) { if (e) { e.classList.add('is-hot'); e.style.setProperty('--hot', 'var(--t' + pr.col + ')'); } }
      if (q.parts && pi > 0 && pr.ai === 0) lite(wrap.querySelector('[data-joinop="' + pi + '"]'));
      var boxes = step.layout === 'box' ? step.host : null;
      if (boxes) boxHotOff(boxes);
      [['0', pr.ai], ['1', pr.bi]].forEach(function (pair) {
        var e = wrap.querySelector('[data-p="' + pi + '"][data-f="' + pair[0] + '"][data-t="' + pair[1] + '"]');
        lite(e);
        if (e && e.previousElementSibling && e.previousElementSibling.classList.contains('eb-op')) lite(e.previousElementSibling);
        var h = boxes ? boxes.querySelector('[data-hp="' + pi + '"][data-hf="' + pair[0] + '"][data-ht="' + pair[1] + '"]') : null;
        if (h) { h.classList.add('is-hot'); h.style.setProperty('--hot', 'var(--t' + pr.col + ')'); }
      });
      if (boxes) { boxes.classList.add('is-guided'); if (step.cells && step.cells[i]) step.cells[i].classList.add('is-now'); }
    }
    /* "x multiplied by +7 gives +7x" under the working, in the product's colour; ask = "gives ?" before the product
       is shown. Every term carries its sign, + included, the way it is written in the working (Aadam, 2026-09-16:
       look at the sign first); only a leading positive term, written with no sign, stays bare. */
    function productCaption(step, i, ask) {
      var pr = step.prods[i], pi = pr.part || 0, src = step.src[pi] || step.src[0];
      var a = src[0][pr.ai], b = src[1][pr.bi], col = 'var(--t' + pr.col + ')';
      elCap.innerHTML = '<span class="cp" style="--hot:' + col + '">' + signedHTML(a, pi === 0 && pr.ai === 0) + '</span><span>multiplied by</span><span class="cp" style="--hot:' + col + '">' + signedHTML(b, pr.bi === 0) + '</span><span>gives</span><span class="cp" style="--hot:' + col + '">' + (ask ? '?' : signedHTML(pr, leadProd(pr))) + '</span>';
    }
    function collectCaption(step, k, ask) {
      var p = step.to[k].p, parts = [];
      step.prods.forEach(function (t, n) { if (t.p === p) parts.push({ t: t, bare: n === 0 }); });
      if (parts.length < 2) { elCap.innerHTML = '<span class="cp">' + signedHTML(step.to[k], k === 0) + '</span><span>has no like terms, so it stays as it is</span>'; return; }
      elCap.innerHTML = parts.map(function (e) { return '<span class="cp" style="--hot:var(--t' + e.t.col + ')">' + signedHTML(e.t, e.bare) + '</span>'; }).join('<span>and</span>') + '<span>collect to</span><span class="cp" style="--hot:var(--ok-text)">' + (ask ? '?' : signedHTML(step.to[k], k === 0)) + '</span>';
    }

    /* ---------- the two presses ---------- */
    function stepIdxLabel(label, done, total) { api.step(S.step, label + ' · ' + done + ' of ' + total); }
    function playExpand(step, done) {
      var i = 0, cells = step.cells || step.host.querySelectorAll('.eb-pt'), box = step.layout === 'box', asked = false;
      step.arcTimers = [];
      function finishAll(keepHot) {
        clearTimeout(S.timer); step.skip = null; step.next = null;
        for (; i < step.prods.length; i++) arcFor(step, i, true);
        settleArcs(step);
        Array.prototype.forEach.call(cells, function (c) { if (c) c.classList.add('is-in'); });
        if (keepHot === true) S.hotLine = step.line; else hotOff(step.line);
        S.busy = false; done();
      }
      step.skip = finishAll;
      function tick() {
        if (i >= step.prods.length) { finishAll(); return; }
        if (!asked) {
          /* press one: light the two terms, their signs and the arc over the brackets (the grid rings the box to fill) */
          hotOn(step, i); arcFor(step, i);
          asked = true;
          if (manual) {
            productCaption(step, i, true);
            keepInView(step.lineEl);
            stepIdxLabel('Expand', i, step.prods.length);
            step.next = tick;
            api.cta(box ? 'Fill the box' : 'Show the product');
            api.hint(box ? 'Multiply the two highlighted terms, then fill the box.' : 'Multiply the two highlighted terms, then show the product.');
            return;
          }
        }
        /* press two: the product */
        asked = false;
        if (cells[i]) cells[i].classList.add('is-in');
        productCaption(step, i);
        i++;
        keepInView(step.lineEl);
        if (!manual) { step.next = null; S.timer = setTimeout(tick, fast ? 10 : 430); return; }
        stepIdxLabel('Expand', i, step.prods.length);
        if (i >= step.prods.length) { finishAll(true); return; }
        step.next = tick;
        if (box) { api.cta('Next box'); api.hint(i + ' of ' + step.prods.length + ' boxes filled. Which box comes next?'); return; }
        api.cta('Next product'); api.hint(i + ' of ' + step.prods.length + ' products found. Which pair of terms comes next?');
      }
      step.tick = tick; S.busy = true;
      if (fast && !manual) { finishAll(); return; }
      tick();
    }
    function playCollect(step, done) {
      var isGrid = step.layout === 'grid', isBox = step.layout === 'box', rule = document.createElement('div'), ansCells = [];
      rule.className = 'eb-rule';
      if (isGrid) {
        rule.style.gridColumn = '1 / -1'; rule.style.gridRow = String(step.grid.rows + 1); step.host.appendChild(rule);
        step.to.forEach(function (t, n) {
          var c = document.createElement('div'); c.className = 'eb-cell eb-ansc';
          var col = step.grid.powers.indexOf(t.p);
          c.style.gridColumn = String((col < 0 ? step.grid.powers.length - 1 : col) + 1); c.style.gridRow = String(step.grid.rows + 2);
          c.innerHTML = opHTML(t.c < 0, n === 0) + '<span>' + bodyHTML(t) + '</span>'; c.style.visibility = 'hidden';
          step.host.appendChild(c); ansCells.push(c);
        });
      } else {
        if (!isBox) step.wrap.appendChild(rule);
        var ansEl = document.createElement('div'); ansEl.className = 'eb-ans'; step.wrap.appendChild(ansEl); step.ansEl = ansEl;
      }
      var k = 0, asked = false;
      function finishAll() {
        clearTimeout(S.timer); step.skip = null; step.next = null;
        if (isGrid) ansCells.forEach(function (c) { c.style.visibility = ''; }); else step.ansEl.innerHTML = polyHTML(step.to);
        Array.prototype.forEach.call(step.host.querySelectorAll('.eb-pt'), function (c) { c.classList.remove('is-merge'); c.style.opacity = ''; });
        step.host.classList.remove('is-gather');
        S.busy = false; done();
      }
      step.skip = finishAll;
      function tick() {
        if (k >= step.to.length) { finishAll(); return; }
        if (step.whole) {
          /* nothing collects: the whole line in one press */
          step.ansEl.innerHTML = polyHTML(step.to);
          elCap.innerHTML = '<span>No like terms to collect, so write the answer out</span>';
          k = step.to.length;
        } else {
          var p = step.to[k].p, cells = step.cells || step.host.querySelectorAll('.eb-pt');
          if (!asked) {
            /* press one: pick out the like terms (the grid dims the rest by class, the arcs layouts inline) */
            Array.prototype.forEach.call(cells, function (c) { if (c) c.classList.remove('is-merge'); });
            step.prods.forEach(function (t, n) { if (!cells[n]) return; if (t.p === p) cells[n].classList.add('is-merge'); if (!isBox) cells[n].style.opacity = t.p === p ? '' : '.35'; });
            if (isBox) step.host.classList.add('is-gather');
            asked = true;
            /* a term with no like terms has nothing to work out, so it stays one press */
            if (manual && step.prods.filter(function (t) { return t.p === p; }).length > 1) {
              collectCaption(step, k, true);
              keepInView(step.lineEl);
              stepIdxLabel('Simplify', k, step.to.length);
              step.next = tick;
              api.cta('Collect');
              api.hint('Collect the highlighted like terms, then press Collect.');
              return;
            }
          }
          /* press two: the collected term */
          asked = false;
          if (isGrid) ansCells[k].style.visibility = ''; else step.ansEl.innerHTML = polyHTML(step.to.slice(0, k + 1));
          collectCaption(step, k);
          k++;
        }
        keepInView(step.lineEl);
        if (!manual) { step.next = null; S.timer = setTimeout(tick, fast ? 10 : 460); return; }
        stepIdxLabel('Simplify', k, step.to.length);
        if (k >= step.to.length) { finishAll(); return; }
        step.next = tick;
        api.cta('Next term'); api.hint(k + ' of ' + step.to.length + ' like terms collected. Which like terms are left?');
      }
      step.tick = tick; S.busy = true;
      if (fast && !manual) { finishAll(); return; }
      tick();
    }

    /* ---------- flow ---------- */
    function setCta() {
      if (!S.steps) { api.cta('Expand'); return; }
      var st = S.steps[S.step];
      if (st) api.cta(st.k === 'exp' ? 'Expand' : (st.whole ? 'Write it out' : 'Simplify'));
    }
    function advanceStep() {
      var st = S.steps[S.step]; if (!st) return;
      if (S.hotLine !== null) { hotOff(S.hotLine); S.hotLine = null; }
      api.step(S.step);
      if (st.k === 'exp') {
        if (st.rewrite && S.lines[0]) { S.lines[0].querySelector('.eb-expr').innerHTML = factorHTML(q.factors[0], 0, 0) + factorHTML(q.factors[1], 1, 0); st.rewrite = false; }
        addWorkBlock(st);
        playExpand(st, function () { S.step++; afterStep(); });
        return;
      }
      var expStep = null, n;
      for (n = S.step - 1; n >= 0; n--) if (S.steps[n].k === 'exp') { expStep = S.steps[n]; break; }
      if (!expStep) return;
      st.host = expStep.host; st.wrap = expStep.wrap; st.lineEl = expStep.lineEl; st.prods = expStep.prods; st.layout = expStep.layout; st.grid = expStep.grid; st.cells = expStep.cells;
      if (S.lines[st.line]) agePast(st.lineEl);
      playCollect(st, function () {
        if (st.restate) { addLabel('now multiply by ' + pretty(EBQ.factorText(st.restate[1]))); addQuestionLine(factorHTML(st.restate[0], 0, 0) + factorHTML(st.restate[1], 1, 0), true); }
        S.step++; afterStep();
      });
    }
    function pretty(s) { return s.replace(/-/g, MINUS).replace(/\^(\d)/g, '<sup>$1</sup>'); }
    function afterStep() {
      if (S.step >= S.steps.length) { S.done = true; elCap.innerHTML = ''; api.hint(''); api.done(); return; }
      setCta();
      api.step(S.step);
      var nx = S.steps[S.step];
      api.hint(nx.k === 'col' ? (nx.whole ? 'No like terms to collect. Write the answer out.' : 'Now collect like terms.') : (nx.layout === 'box' ? 'Now fill in the next grid.' : 'Multiply the next pair of terms.'));
    }
    function next() {
      if (dead || S.done) return;
      S.presses = (S.presses || 0) + 1;
      if (S.busy) { var run = S.steps && S.steps[S.step]; if (run && run.next) { run.next(); return; } if (run && run.skip) run.skip(); return; }
      if (q.door === 'triple' && !S.steps) {
        S.steps = buildSteps(S.pair); elPairs.style.display = 'none';
        addLabel('start with ' + pretty(EBQ.factorText(q.factors[S.pair[0]]) + EBQ.factorText(q.factors[S.pair[1]])));
        addQuestionLine(pairHTML(q, S.pair));
        api.steps(['Choose a pair'].concat(stepLabels())); api.step(1);
        /* the chips count the pair choice as step 0, so shift the index the
           renderer reports - once only, or a replay would shift it again */
        if (!S.shifted) { S.shifted = true; S.rawStep = api.step; api.step = function (i, l) { S.rawStep(i + 1, l); }; }
      }
      if (!S.steps || S.step >= S.steps.length) return;
      advanceStep();
    }
    function all() {
      if (dead || S.done) return;
      var wasFast = fast, wasManual = manual;
      fast = true; manual = false;
      var guard = 0;
      while (!S.done && guard++ < 20) {
        if (S.busy) { var run = S.steps && S.steps[S.step]; if (run && run.skip) run.skip(); else break; continue; }
        if (q.door === 'triple' && !S.steps) { next(); continue; }
        if (!S.steps || S.step >= S.steps.length) break;
        advanceStep();
        var st = S.steps[S.step - (S.busy ? 0 : 1)];
        if (S.busy && st && st.skip) st.skip();
      }
      fast = wasFast; manual = wasManual;
      if (!S.done) afterStep();
    }
    /* Nothing here can be un-written - each press adds a line of working - so one
       press back rebuilds the page from the question and presses forward to one
       press fewer, with the animation off. It counts PRESSES, not steps: a step
       writes several products, one per press, and counting steps sent Left from
       the first product all the way back to the start. With the animation off a
       press in step-by-step mode lands at once, so the replay needs no timers. */
    function replayTo(target, pair) {
      var wasFast = fast; fast = true;
      clearTimeout(S.timer);
      start();
      if (pair) {
        S.pair = pair;
        var n = PAIRS.indexOf(pair);
        Array.prototype.forEach.call(elPairRow.querySelectorAll('.eb-pair'), function (x, i) { x.classList.toggle('is-on', i === n); });
      }
      var guard = 0;
      while (S.presses < target && !S.done && guard++ < 200) next();
      fast = wasFast;
    }
    function back() {
      if (dead) return;
      var pair = (q.door === 'triple') ? S.pair : null, total = S.presses || 0;
      /* finished by Show it all, which is not pressed through: count the presses a finish takes */
      if (S.done) {
        var realDone = api.done; api.done = function () {};
        try { replayTo(Infinity, pair); } finally { api.done = realDone; }
        total = S.presses;
      }
      if (total <= 0) return;
      replayTo(total - 1, pair);
    }
    function start() {
      elWork.innerHTML = ''; elCap.innerHTML = ''; S.lines = []; S.step = 0; S.busy = false; S.done = false; S.hotLine = null; S.presses = 0;
      addQuestionLine(questionHTML(q));
      if (q.door === 'triple') {
        S.steps = null; elPairs.style.display = ''; elPairRow.innerHTML = '';
        var pick = bestPairIndex();
        PAIRS.forEach(function (pr, n) { var b = document.createElement('button'); b.type = 'button'; b.className = 'eb-pair' + (n === pick ? ' is-on' : ''); b.innerHTML = pairHTML(q, pr); b.setAttribute('data-n', String(n)); elPairRow.appendChild(b); });
        S.pair = PAIRS[pick];
        api.steps(['Choose a pair', 'Expand', 'Simplify', 'Expand', 'Simplify']); (S.rawStep || api.step)(0);
        api.hint(pick === 0 && !q.factors.some(function (A) { return A.some(function (t) { return t.c < 0; }); }) ? 'Start with the two simplest brackets, then press Expand. Tap another pair to change.' : 'Start with the highlighted pair, then press Expand. Tap another pair to change.');
      } else {
        elPairs.style.display = 'none';
        S.steps = buildSteps();
        api.steps(stepLabels()); api.step(0);
        api.hint(boxOn ? 'Work it out on paper first. One press shows which terms to multiply, the next fills the box.' : 'Work it out on paper first. One press shows which terms to multiply, the next writes the product.');
      }
      setCta();
    }
    elPairRow.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.eb-pair') : null; if (!b || S.steps) return;
      Array.prototype.forEach.call(elPairRow.querySelectorAll('.eb-pair'), function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on'); S.pair = PAIRS[Number(b.getAttribute('data-n'))];
    });
    function onResize() { if (dead) return; colsFit(); for (var i = 0; i < S.lines.length; i++) clearArcs(i); }
    window.addEventListener('resize', onResize);
    start();
    function where() { return { n: S.presses || 0, pair: S.pair ? S.pair.slice() : null }; }
    function seek(w) {
      if (dead || !w) return;
      var pair = null;
      if (q.door === 'triple' && w.pair) PAIRS.forEach(function (pr) { if (pr.join() === w.pair.join()) pair = pr; });
      if (w.n > 0 || pair) replayTo(w.n, pair);
    }
    return { next: next, back: back, all: all, where: where, seek: seek, destroy: function () { dead = true; clearTimeout(S.timer); window.removeEventListener('resize', onResize); } };
  }

  /* ============================================================
     FOUR SKILLS ON ONE ENGINE
     ============================================================ */
  var TEACH_OPTS = [{ id: 'grid', label: 'Grid method' }];
  SL.register({ id: 'expanding-single-brackets', name: 'Expanding single brackets', short: 'Single brackets', strand: 'algebra', stage: 'secondary', colour: 'orange', icon: 'bracket1', eg: '3(x + 4),  x(2x ' + MINUS + ' 5)', blurb: 'Multiply the term outside by every term inside the bracket, sign included.', aliases: ['expand', 'multiply out', 'single bracket', 'expanding brackets'], levels: LEVELS.single, make: makeFor('single'), teach: teach, teachOpts: TEACH_OPTS, fields: fieldsFor });
  SL.register({ id: 'expanding-double-brackets', name: 'Expanding double brackets', short: 'Double brackets', strand: 'algebra', stage: 'secondary', colour: 'violet', icon: 'bracket2', eg: '(x + 2)(x ' + MINUS + ' 5)', blurb: 'Multiply every term in the first bracket by every term in the second. Then collect the like terms.', aliases: ['FOIL', 'quadratic expansion', 'double brackets', 'binomial'], levels: LEVELS.double, make: makeFor('double'), teach: teach, teachOpts: TEACH_OPTS, fields: fieldsFor });
  SL.register({ id: 'expanding-triple-brackets', name: 'Expanding three brackets', short: 'Three brackets', strand: 'algebra', stage: 'secondary', colour: 'green', icon: 'bracket3', eg: '(x + 1)(x + 2)(x + 3)', blurb: 'Expand two of the brackets first, simplify, then multiply the result by the third bracket.', aliases: ['triple brackets', 'cubic expansion', 'three brackets'], levels: LEVELS.triple, make: makeFor('triple'), teach: teach, teachOpts: TEACH_OPTS, fields: fieldsFor });
  SL.register({ id: 'expanding-surd-brackets', name: 'Expanding brackets with surds', short: 'Surd brackets', strand: 'algebra', stage: 'secondary', colour: 'gold', icon: 'root', eg: '(2 + ' + SR(3) + ')(1 ' + MINUS + ' ' + SR(3) + ')', blurb: 'Expand as usual, then simplify: a square root multiplied by itself gives the number under it.', aliases: ['surds', 'square roots', 'surd brackets'], levels: LEVELS.surd, make: makeFor('surd'), teach: teach, teachOpts: TEACH_OPTS, fields: fieldsFor });
})();
